import {
  FaPenFancy,
  FaCalendarAlt,
  FaPlay,
  FaFacebookSquare,
  FaInstagramSquare,
  FaTwitterSquare,
  FaAngleRight,
  FaAngleLeft,
  FaRegEnvelope,
} from "react-icons/fa";
import { RxAvatar } from "react-icons/rx";
import { TfiCommentAlt } from "react-icons/tfi";
import Button from "../components/Button";

export default function Blog() {
  return (
    <>
      {/* image container */}
      <div className=" w-full h-[25rem] bg-slate-400 overflow-hidden rounded-sm">
        <img
          alt=""
          className=" w-full h-full block object-cover"
          src={require("../assets/blogs/blog01.png")}
        />
      </div>
      {/* icons container */}
      <div className="my-3 text-sm flex font-semibold">
        <div className="flex items-center">
          <FaPenFancy color="#FB2E86" />
          <div className=" py-1 bg-[#FFE7F9] rounded-md inline-block px-3 ml-3">
            Ahmed azad
          </div>
        </div>
        <div className="flex items-center ml-5">
          <FaCalendarAlt color="#FFA454" />
          <div className=" py-1 bg-[#FFECE2] rounded-md inline-block px-3 ml-3">
            20/2/2022
          </div>
        </div>
      </div>
      {/* title */}
      <h2 className=" text-2xl font-bold mb-2">
        Elit minim sint nisi officia occaecat
      </h2>
      {/* description */}
      <p className=" text-sub_text_color text-sm font-fontTwo mb-2">
        Amet in quis proident qui pariatur aute commodo ipsum. Tempor non aute
        non enim sit duis labore cupidatat veniam ullamco nisi. Officia cillum
        elit minim sint nisi officia occaecat adipisicing excepteur aliquip.
        Commodo incididunt proident occaecat dolor cillum ipsum et et anim
        eiusmod laboris. Sunt mollit nulla aliqua nulla do fugiat proident sit.
        Duis eiusmod labore deserunt excepteur. Ut non elit proident sit. Duis
        eiusmod labore deserunt excepteur.
        <br />
        <br />
        <br />
        Ut non elit voluptate tempor. Sunt veniam magna occaecat fugiat tempor
        dolor in duis ut enim ut. Quis eiusmod aute consectetur culpa in non
        nisi laborum non fugiat cupidatat commodo mollit. Aliqua commodo ut ut
        exercitation consectetur qui mollit veniam. nim sint nisi officia
        occaecat adipisicing excepteur aliquip. Commodo incididunt proident
        occaecat dolor cillum ipsum et et anim eiusmod laboris. Sunt
      </p>
      <Quote>
        Et exercitation incididunt laboris anim eiusmod irure nulla eu proident.
        Et exercitation incididunt laboris anim eiusmod irure nulla eu proident.
      </Quote>
      <div className="flex my-7 justify-between">
        <div className=" h-48 w-80 relative">
          <button className="rounded-full p-4 absolute bg-white left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <FaPlay className="text-pink" />
          </button>
          <img
            alt=""
            className=" object-cover w-full h-full"
            src={require("../assets/blogs/blog01.png")}
          />
        </div>
        <div className=" h-48 w-80">
          <img
            alt=""
            className=" object-cover w-full h-full"
            src={require("../assets/blogs/blog02.png")}
          />
        </div>
      </div>
      <p className=" text-sub_text_color text-sm font-fontTwo mb-2">
        Amet in quis proident qui pariatur aute commodo ipsum. Tempor non aute
        non enim sit duis labore cupidatat veniam ullamco nisi. Officia cillum
        elit minim sint nisi officia occaecat adipisicing excepteur aliquip.
        Commodo incididunt proident occaecat dolor cillum ipsum et et anim
        eiusmod laboris.
      </p>
      <div className="flex justify-center">
        <FaFacebookSquare className="mx-2" color="#5625DF" size={25} />
        <FaInstagramSquare className="mx-2" color="#FF27B7" size={25} />
        <FaTwitterSquare className="mx-2" color="#37DAF3" size={25} />
      </div>
      <div className="flex w-full bg-[#F7F8FB] text-sub_text_color font-fontTwo mt-7 px-2 h-10 items-center justify-between ">
        <a href="/" className="flex items-center">
          <FaAngleLeft />
          Previous
        </a>
        <a href="/" className="flex items-center">
          Next
          <FaAngleRight />
        </a>
      </div>
      {/* comments */}
      <div>
        <div className="flex items-start px-3 py-4 mt-10 shadow-custom_two">
          <div className=" h-32 w-32 bg-red-300">
            <img
              alt=""
              className="w-full h-full object-cover"
              src={require("../assets/blogs/blog02.png")}
            />
          </div>
          <div className="flex-1 pl-3 ">
            <div className=" flex font-fontOne items-center">
              <h4 className=" text-lg font-bold mr-5">Next Man</h4>
              <div className=" text-sub_text_color text-xs">20/2/2021</div>
            </div>
            <p className="text-sm text-sub_text_color font-fontTwo">
              Enim duis commodo anim exercitation ut consequat consectetur
              reprehenderit consequat. Reprehenderit esse qui deserunt eiusmod
              quis.
            </p>
          </div>
        </div>
      </div>
      <div className=" mt-10 text-sub_text_color">
        <div className="flex justify-between">
          {/* input text (username)*/}
          <div className="flex items-center w-full py-2 border-2 pl-1 mr-2">
            <RxAvatar />
            <input
              className="flex-1 ml-2 focus:outline-none bg-transparent"
              placeholder="username"
              type={"text"}
            />
          </div>
          {/* input text (Email)*/}
          <div className="flex items-center py-2 border-2 pl-1 w-full ml-2">
            <FaRegEnvelope />
            <input
              className="flex-1 ml-2 focus:outline-none bg-transparent"
              placeholder="E-mail"
              type={"text"}
            />
          </div>
        </div>
        {/* input text (comment) */}
        <div className="flex group items-start py-2 mt-4 border-2 pl-1 w-full">
          <TfiCommentAlt className=" ml-1 translate-y-1 group" />
          <textarea
            className="ml-2 focus:outline-none bg-transparent block w-full"
            placeholder="your comment"
            rows={10}
          ></textarea>
        </div>
        <label className="flex text-sm w-full py-2 pl-1 mr-2 ">
          <input type={"checkbox"} />
          Save my email and name in this browser for the next time I comment
        </label>
        <Button className="w-full mt-4" color={"pink"}>
          Continue Shopping
        </Button>
      </div>
    </>
  );
}

function Quote({ children }) {
  return (
    <p className=" border-l-2 text-sub_text_color border-pink bg-[#FAFAFB] my-8 py-4 px-3">
      <i>{children}</i>
    </p>
  );
}
